import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';
import {
    PAGE,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { ButtonNewTabInep } from '../Buttons/ButtonsNewTab';

import { moneyMask, numberFormat } from '../../helper/MaskHelper';

import { patternAdminDep } from '../../variables/Enums/DependenciaAdministrativa';

export class DadosMedalhas extends Component {
    constructor (props) {
        super(props);
        this.state = {
            page: PAGE,
            size: 25,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
        }
    }

    sumEscolas = () => this.props.schools.length;
    sumMedalhasOuro = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.ouro, 10), 0);
    sumMedalhasPrata = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.prata, 10), 0);
    sumMedalhasBronze = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.bronze, 10), 0);
    sumTotalMedalhas = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.total, 10), 0);
    sumPagamentosInscricao = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.valorInscricao, 10), 0);
    sumPagamentosPremiacao = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.valorPremiacao, 10), 0);
    sumPagamentosTotal = () => this.props.schools.reduce((total, sch) => total + parseInt(sch.valorTotal, 10), 0);

    // PAGINAÇÃO APENAS NA VIEW
    handlePage = (value) => this.setState({ ...this.state, page: value, });
    handleRowsPerPage = (value) => this.setState({ ...this.state, size: value, page: 0, });
    handleTotalPages = () => Math.ceil(this.props.schools.length / this.state.size);
    handleTotalElements = () => this.props.schools.length;

    newTabInep = (inep) => <ButtonNewTabInep inep={inep} />

    render () {
        const columns = [
            { label: 'INEP', name: 'inep', func: this.newTabInep, key: true, width: '5', ordering: false, orderLabel: 'asc', },
            { label: 'Escola', name: 'nome', func: null, key: false, width: '20', ordering: false },
            { label: 'Dep. Adm.', name: 'dependencia', func: patternAdminDep, key: false, width: '5', ordering: false },
            { label: 'Medalhas de Ouro', name: 'ouro', func: numberFormat, key: false, width: '5', ordering: false },
            { label: 'Medalhas de Prata', name: 'prata', func: numberFormat, key: false, width: '5', ordering: false },
            { label: 'Medalhas de Bronze', name: 'bronze', func: numberFormat, key: false, width: '5', ordering: false },
            { label: 'Total de Medalhas', name: 'total', func: numberFormat, key: false, width: '5', ordering: false },
            { label: 'Valor de Inscrição', name: 'valorInscricao', func: moneyMask, key: false, width: '5', ordering: false },
            { label: 'Valor de Premiação', name: 'valorPremiacao', func: moneyMask, key: false, width: '5', ordering: false },
            { label: 'Valor Total', name: 'valorTotal', func: moneyMask, key: false, width: '5', ordering: false },
            { label: 'Endereço', name: 'endereco', func: null, key: false, width: '5', ordering: false },
            { label: 'Número', name: 'numero', func: null, key: false, width: '5', ordering: false },
            { label: 'Bairro', name: 'bairro', func: null, key: false, width: '5', ordering: false },
            { label: 'CEP', name: 'cep', func: null, key: false, width: '5', ordering: false },
            { label: 'Municipio', name: 'municipio', func: null, key: false, width: '5', ordering: false },
            { label: 'UF', name: 'uf', func: null, key: false, width: '5', ordering: false },
            { label: 'Objeto Postal', name: 'objetoPostalMedalhas', func: null, key: false, width: '5', ordering: false },
        ];
        
        const actions = [];

        const totals = [
            { column: 0, label: 'Totais', value: "#", width: '5', },
            { column: 1, label: 'Escolas', value: numberFormat(this.sumEscolas()), width: '15', },
            { column: 2, label: 'Medalhas de Ouro', value: numberFormat(this.sumMedalhasOuro()), width: '10', },
            { column: 3, label: 'Medalhas de Prata', value: numberFormat(this.sumMedalhasPrata()), width: '10', },
            { column: 4, label: 'Medalhas de Bronze', value: numberFormat(this.sumMedalhasBronze()), width: '10', },            
            { column: 5, label: 'Total de Medalhas', value: numberFormat(this.sumTotalMedalhas()), width: '10', },
            { column: 6, label: 'Valor Total de Inscrições', value: moneyMask(this.sumPagamentosInscricao()), width: '15', },
            { column: 7, label: 'Valor Total de Premiações', value: moneyMask(this.sumPagamentosPremiacao()), width: '15', },
            { column: 8, label: 'Valor Total', value: moneyMask(this.sumPagamentosTotal()), width: '20', },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.schools.slice(this.state.page * this.state.size, (this.state.page * this.state.size) + this.state.size)}
                        actions={actions}
                        page={this.state.page}
                        handlePage={this.handlePage}
                        handleTotalPages={this.handleTotalPages}
                        handleTotalElements={this.handleTotalElements}
                        rowsPerPage={this.state.size}
                        handleRowsPerPage={this.handleRowsPerPage}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} showHead={true} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosMedalhas;